import { getSafariVersion } from './browser.utils';

// TODO: remove this once Safari 16 fixes their bug with decimal point on number inputs
// TODO: because price input should always be number and not tel
export const getInputTypeByDevice = (): string => {
    const safariVersion = getSafariVersion();
    if (safariVersion && getMajorVersion(safariVersion) >= 16) {
        return 'tel';
    }
    return 'number';
};

const getMajorVersion = (version: string) => Number(version.split('.')[0]);
